import { Component, HostBinding, OnDestroy } from '@angular/core';
import { ControlValueAccessor, FormControl, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-phone-number-input',
  templateUrl: './phone-number-input.component.html',
  styleUrls: ['./phone-number-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: PhoneNumberInputComponent,
    },
  ],
})
export class PhoneNumberInputComponent implements ControlValueAccessor, OnDestroy {
  @HostBinding('class.disabled') disabled = false;
  phoneNumberForm: FormGroup;

  private touched = false;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private onChange = (value: string) => {};
  private onTouched = () => {};

  private subscriptions = new Subscription();

  constructor() {
    this.phoneNumberForm = new FormGroup({
      countryCode: new FormControl(),
      phoneNumber: new FormControl(),
    });
    this.subscriptions.add(
      this.countryCode.valueChanges.subscribe(valueFromIonicComponent => {
        this.markAsTouched();
        this.onChange(valueFromIonicComponent);
      })
    );
    this.subscriptions.add(
      this.phoneNumber.valueChanges.subscribe(valueFromIonicComponent => {
        this.markAsTouched();
        this.onChange(valueFromIonicComponent);
      })
    );
  }

  private get countryCode() {
    return this.phoneNumberForm.get('countryCode');
  }

  private get phoneNumber() {
    return this.phoneNumberForm.get('phoneNumber');
  }

  private markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  //
  // implementation of ControlValueAcccessor
  //

  writeValue(value: any) {
    this.countryCode.setValue(value ? value.countryCode : '');
    this.phoneNumber.setValue(value ? value.phoneNumber : '');
  }

  registerOnChange(onChange: any) {
    this.subscriptions.add(this.phoneNumberForm.valueChanges.subscribe(onChange));
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
    if (disabled) {
      this.countryCode.disable({ emitEvent: false });
      this.phoneNumber.disable({ emitEvent: false });
    } else {
      this.countryCode.enable({ emitEvent: false });
      this.phoneNumber.enable({ emitEvent: false });
    }
  }

  ngOnDestroy() {
    this.subscriptions?.unsubscribe();
  }
}
